module.exports = __webpack_public_path__ + "img/record_2.079e36a0.png";